import React from 'react';
import { Collapse } from 'antd';
import { CollapseProps } from 'antd/lib';
import WorkingTime from '../WorkingTime';
import { normalizeOpenHours } from 'utils/timeHelpers';
import { FarmInfrastructures } from 'types/FarmData';
import { FarmInfrastructuresWrapper } from './style';
import { Icon } from 'ui';

interface InfrastructureProps {
  daysOfWeek: string[];
  infrastructures: FarmInfrastructures[] | undefined;
}

const Infrastructures: React.FC<InfrastructureProps> = ({
  daysOfWeek,
  infrastructures = [],
}) => {
  const items: CollapseProps['items'] = infrastructures
    .filter((infrastructure) => infrastructure.status !== false)
    .map((infrastructure) => ({
      key: infrastructure.id,
      label: infrastructure.object_name,
      children: (
        <WorkingTime
          workingTime={normalizeOpenHours(infrastructure.open_hours)}
          daysOfWeek={daysOfWeek}
        />
      ),
    }));

  return (
    <FarmInfrastructuresWrapper className="farm-partner">
      <Collapse
        expandIconPosition="end"
        className="custom-collapse"
        items={items}
        expandIcon={({ isActive }) => (
          <Icon
            name={'arrow-down'}
            type={'avarage'}
            style={{
              transition: 'transform 0.3s',
              transform: isActive ? 'rotate(180deg)' : '',
            }}
          />
        )}
      />
    </FarmInfrastructuresWrapper>
  );
};

export default Infrastructures;
